'use client';

import { CSSProperties, FC } from 'react';
import { useResolveThemeColor } from '@/hooks/use-resolve-theme-color';

export type LocationItem = { name: string; address: string };
export type LocationsSection = { name: string; items: LocationItem[] };

type ShopsLocationsListProps = {
  title: string;
  background?: string;
  regionColor?: string;
  locationColor?: string;
  addressColor?: string;
  sections: LocationsSection[];
  className?: string;
  paddingStyle?: CSSProperties;
};

const StoreLocationsList: FC<ShopsLocationsListProps> = ({
  title,
  background = '#ffffff',
  regionColor = '#dc2626',
  locationColor = '#000000',
  addressColor = '#000000',
  sections,
  className,
  paddingStyle,
}) => {
  const resolveThemeColor = useResolveThemeColor();

  return (
    <div
      className={className}
      style={{ backgroundColor: resolveThemeColor(background) || background }}
    >
      <div className="container mx-auto" style={paddingStyle}>
        <h2 className="mb-8 text-left text-3xl font-bold tracking-tight text-black md:text-4xl @sm:text-3xl">
          {title}
        </h2>
        <div className="flex flex-col gap-10">
          {sections.map((region, regionIndex) => (
            <div key={regionIndex} className="flex flex-col gap-6">
              <h3
                className="text-xl font-bold"
                style={{ color: resolveThemeColor(regionColor) || regionColor }}
              >
                {region.name || 'Region'}
              </h3>
              <div className="grid grid-cols-1 gap-x-8 gap-y-4 @sm:grid-cols-3 @lg:grid-cols-4 @xl:grid-cols-4">
                {region.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="flex h-full flex-col gap-0.5 p-2">
                    <span
                      className="font-semibold"
                      style={{ color: resolveThemeColor(locationColor) || locationColor }}
                    >
                      {item.name || '—'}
                    </span>
                    <span
                      className="text-sm font-normal"
                      style={{ color: resolveThemeColor(addressColor) || addressColor }}
                    >
                      {item.address || '—'}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StoreLocationsList;
